import React, { useState, useRef } from 'react';
import { Avatar, Button, Checkbox, Col, DatePicker, Drawer, Form, Input, InputNumber, Row, Space, Tabs, Table, message, Select, Upload } from 'antd';
import { UploadOutlined, UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { actualizarFotoEmpleado, createEmpleado, getEmpleadoById, getNominaRegimenSalarialList, getOdooHorarioList, getTipoContratoList, updateById } from '../../../../apis/OdooApi';
import {getList as getAllPeriodos} from '../../../../apis/PeriodosApi';
import { getByIdEmpleado } from "../../../../apis/OdooMovimientoEmpleadoApi";
import { getList as getAnaliticas} from "../../../../apis/OdooAnaliticaApi";
import { getList as getPuestos } from '../../../../apis/OdooPuestoApi';
import { getAll as getSupervisores } from '../../../../apis/SupervisoresApi';
import { getList as getDepartamentos } from '../../../../apis/OdooDepartamentoApi';
import { getList as getIntegraciones } from '../../../../apis/IntegracionApi';
import { getList as getAreasTrabajo } from '../../../../apis/AreasTrabajoApi';
import { getBancosOdoo } from '../../../../apis/BancosApi';
import { getList as getRegistroPatronalList } from '../../../../apis/RegistroPatronalApi';
import { getFactorIntegracion, getSalarioDiarioIntegradoDirecto } from '../../../../apis/CalculoIntegradoApi';

const { Option } = Select;
const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm();
    const isEdit = Boolean(id && id > 0);
  const nominaNombre = Form.useWatch('nomina_name', form);
  const apellidoPaterno = Form.useWatch('nomina_first_last_name', form);
  const apellidoMaterno = Form.useWatch('nomina_second_last_name', form);
  const salarioDiario = Form.useWatch('nomina_daily_salary', form);
  const nominaEntryDate = Form.useWatch('nomina_entry_date', form);
  const nominaSeniorityDate = Form.useWatch('nomina_seniority_date', form);
  const nominaContractStartDate = Form.useWatch('nomina_contract_start_date', form);
  const nominaIntegrationId = Form.useWatch('nomina_integration_id', form);
  const nominaVariableAmount = Form.useWatch('nomina_variable_amount', form);
  const nominaFixedAmount = Form.useWatch('nomina_fixed_amount', form);
    const debounceRef = useRef(null);
    const [tipoPeriodo, setTipoPeriodo] = useState([]);
    const [kardex, setKardex] = useState([]);
    const [loadingKardex, setLoadingKardex] = useState(false);
    const [analiticas, setAnaliticas] = useState([]);
    const [puestos, setPuestos] = useState([]);
    const [supervisores, setSupervisores] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [integraciones, setIntegraciones] = useState([]);
    const [areasTrabajo, setAreasTrabajo] = useState([]);
    const [bancos, setBancos] = useState([]);
    const [registroPatronalList, setRegistroPatronalList] = useState([]);
    const [regimenesSalariales, setRegimenesSalariales] = useState([]);
    const [horarios, setHorarios] = useState([]);
    const [tiposContrato, setTiposContrato] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [selectedFoto, setSelectedFoto] = useState(null);
    const [existingFoto, setExistingFoto] = useState(null);
    const [fotoUploading, setFotoUploading] = useState(false);

    const DATE_FIELDS = [
      'nomina_entry_date',
      'nomina_seniority_date',
      'nomina_contract_start_date',
      'nomina_contract_end_date',
    ];

    const composeNombreCompleto = (fields) => {
      return [fields.nomina_name, fields.nomina_first_last_name, fields.nomina_second_last_name]
        .map((value) => (value || '').trim())
        .filter((value) => value.length > 0)
        .join(' ');
    };

    const buildPayloadForCreate = (fields) => {
      const payload = { ...fields };
      payload.activo = true;
      payload.nomina_need_timesheets = Boolean(fields.nomina_need_timesheets);

      const selectedPuesto = puestos.find((item) => item.value === fields.job_id);
      if (selectedPuesto) {
        payload.job_title = selectedPuesto.text;
      }

      DATE_FIELDS.forEach((key) => {
        payload[key] = fields[key] ? fields[key].format('YYYY-MM-DD') : null;
      });
      payload.name = composeNombreCompleto(fields);
      if (fields.nomina_daily_salary !== undefined && fields.nomina_daily_salary !== null) {
        payload.nomina_monthly_salary = Number((Number(fields.nomina_daily_salary) * 30).toFixed(2));
      }

      const selectedBanco = bancos.find((item) => item.id === fields.banco_id);
      if (selectedBanco) {
        payload.banco_name = selectedBanco.display_name || selectedBanco.name;
      }

      payload.nomina_employer_registration_key = fields.nomina_employee_registration_key;
      payload.nomina_can_reenter = Boolean(fields.nomina_can_reenter);
      payload.nomina_integration_factor = fields.nomina_integration_factor;
      payload.nomina_integrated_salary = fields.nomina_integrated_salary;
      payload.foto = selectedFoto;
      return payload;
    };

    const mapInitialValues = (item) => {
      if (!item) {
        return null;
      }

      const mapped = { ...item };
      DATE_FIELDS.forEach((key) => {
        mapped[key] = item[key] ? dayjs(item[key]) : null;
      });
      return mapped;
    };

    const normalizeFotoSrc = (foto) => {
      if (!foto) return null;
      if (foto.startsWith('data:')) return foto;
      return `data:image/png;base64,${foto}`;
    };

    const fileToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    const beforeFotoUploadEdit = async (file) => {
      if (!file.type.startsWith('image/')) {
        message.error('El archivo debe ser una imagen válida');
        return Upload.LIST_IGNORE;
      }

      setFotoUploading(true);
      try {
        const fotoBase64 = await fileToBase64(file);
        if (isEdit) {
          const response = await actualizarFotoEmpleado(id, fotoBase64);
          if (response?.ok) {
            message.success('Foto actualizada correctamente');
            setExistingFoto(fotoBase64);
          } else {
            message.error('No se pudo actualizar la foto');
          }
        } else {
          setSelectedFoto(fotoBase64);
        }
      } catch (e) {
        message.error('Error al subir la foto');
      } finally {
        setFotoUploading(false);
      }
      return false;
    };

    const handleOk = async () => {
        try {
            const fields = await form.validateFields();
            if (isEdit) {
                const payload = {
                    id,
                    periodo_id : fields.periodo_id,
                    analitica_id : fields.analitica_id,
                };
                const response = await updateById(payload);
                if (response.ok) {
                    message.success('Se actualizó correctamente el empleado.');
                    finish(true, true);
                }
                return;
            }

            const payload = buildPayloadForCreate(fields);
            const response = await createEmpleado(payload);
            if (response.ok) {
              message.success('Empleado creado correctamente.');
              finish(true, false);
            }
        } catch (errorInfo) {
            message.error('Por favor completa todos los campos obligatorios.');
        }
    };

    const onClose = ()=>{
        finish(false);
        form.resetFields();
        setKardex([]);
    };

    React.useEffect(() => {
      if (!open) {
        return;
      }

      (async () => {
        setLoadingData(true);
        await getCatalogs();
        if (isEdit) {
          await refreshData();
          await loadKardex(id);
        } else {
          form.setFieldsValue({
            activo: true,
            nomina_need_timesheets: false,
            periodo_id: undefined,
            analitica_id: undefined,
          });
          setKardex([]);
        }
        setLoadingData(false);
      }
      )();
    }, [id, isEdit, open]);

    React.useEffect(() => {
      if (isEdit) {
        return;
      }
      if (salarioDiario === undefined || salarioDiario === null) {
        form.setFieldValue('nomina_monthly_salary', undefined);
        return;
      }
      const salarioMensual = Number((Number(salarioDiario) * 30).toFixed(2));
      form.setFieldValue('nomina_monthly_salary', salarioMensual);
    }, [salarioDiario, isEdit]);

    React.useEffect(() => {
      if (isEdit) return;
      if (!nominaEntryDate) return;
      if (!nominaSeniorityDate) form.setFieldValue('nomina_seniority_date', nominaEntryDate);
      if (!nominaContractStartDate) form.setFieldValue('nomina_contract_start_date', nominaEntryDate);
    }, [nominaEntryDate, nominaSeniorityDate, nominaContractStartDate, isEdit]);

    React.useEffect(() => {
      if (isEdit) return;
      if (!nominaEntryDate || !nominaIntegrationId || salarioDiario === undefined || salarioDiario === null) {
        form.setFieldValue('nomina_integration_factor', undefined);
        form.setFieldValue('nomina_integrated_salary', undefined);
        return;
      }
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(async () => {
        try {
          const fechaActual = dayjs().format('YYYY-MM-DD');
          const fechaIngreso = nominaEntryDate.format('YYYY-MM-DD');
          const factorResponse = await getFactorIntegracion(fechaActual, fechaIngreso, nominaIntegrationId);
          if (factorResponse.ok) {
            const factor = factorResponse.payload;
            form.setFieldValue('nomina_integration_factor', factor);
            const sdiResponse = await getSalarioDiarioIntegradoDirecto(
              salarioDiario, factor, nominaVariableAmount || 0, nominaFixedAmount || 0
            );
            if (sdiResponse.ok) {
              form.setFieldValue('nomina_integrated_salary', sdiResponse.payload);
            }
          }
        } catch (e) {
          console.error('Error calculando integración', e);
        }
      }, 600);
      return () => { if (debounceRef.current) clearTimeout(debounceRef.current); };
    }, [nominaEntryDate, nominaIntegrationId, salarioDiario, nominaVariableAmount, nominaFixedAmount, isEdit]);

    const refreshData = async ()=> {
        const response = await getEmpleadoById(id);
        if(response.ok){
            const item = mapInitialValues(response.payload);
            form.setFieldsValue(item);
            setExistingFoto(response.payload.foto || null);
        }
    };

    const getCatalogs = async ()=> {
        const responsePeriodos = await getAllPeriodos();
        const responseAnaliticas = await getAnaliticas();
        const responsePuestos = await getPuestos();
        const responseSupervisores = await getSupervisores();
        const responseDepartamentos = await getDepartamentos();
        const responseIntegraciones = await getIntegraciones();
        const responseAreasTrabajo = await getAreasTrabajo();
        const responseBancos = await getBancosOdoo();
        const responseRegimenesSalariales = await getNominaRegimenSalarialList();
        const responseHorarios = await getOdooHorarioList();
        const responseTiposContrato = await getTipoContratoList();

        if(responsePeriodos.ok){
          let items = responsePeriodos.payload;
          setTipoPeriodo(items);
        }
        if(responseAnaliticas.ok){
          let items = responseAnaliticas.payload;
          setAnaliticas(items);
        }

        if(responsePuestos.ok){
          setPuestos(responsePuestos.payload || []);
        }

        if(responseSupervisores.ok){
          const options = (responseSupervisores.payload || [])
            .filter((item) => item.odoo_id || item.id)
            .map((item) => ({
              value: item.odoo_id || item.id,
              text: item.nombre || item.empleado_one2many_name || `Supervisor ${item.id}`,
            }));
          setSupervisores(options);
        }

        if(responseDepartamentos.ok){
          setDepartamentos(responseDepartamentos.payload || []);
        }

        if(responseIntegraciones.ok){
          setIntegraciones(responseIntegraciones.payload || []);
        }

        if(responseAreasTrabajo.ok){
          setAreasTrabajo(responseAreasTrabajo.payload || []);
        }

        if(responseBancos?.ok){
          setBancos(responseBancos.payload || []);
        }

        if(responseRegimenesSalariales?.ok){
          setRegimenesSalariales(responseRegimenesSalariales.payload || []);
        }

        if(responseHorarios?.ok){
          setHorarios(responseHorarios.payload || []);
        }

        if(responseTiposContrato?.ok){
          setTiposContrato(responseTiposContrato.payload || []);
        }

        const responseRegistroPatronalList = await getRegistroPatronalList();
        if(responseRegistroPatronalList?.ok){
          setRegistroPatronalList(responseRegistroPatronalList.payload || []);
        }
    };

    const loadKardex = async (empleadoId) => {
      if (!empleadoId) {setKardex([]); return;}
      setLoadingKardex(true);
      try {
        const response = await getByIdEmpleado(empleadoId);
        setKardex(response?.ok ? (response.payload ?? []) : []);
      } catch (e) {
        setKardex([]);
        message.error("Error cargando el kardex del empleado.");
      }finally {
        setLoadingKardex(false);
      }
    };

    const renderEditForm = () => (
      <>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <Upload beforeUpload={beforeFotoUploadEdit} showUploadList={false} accept="image/*" disabled={fotoUploading}>
            <div style={{ position: 'relative', width: 120, height: 120, borderRadius: 8, overflow: 'hidden', cursor: 'pointer', border: '1px solid #d9d9d9', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' }}>
              {existingFoto ? (
                <img src={normalizeFotoSrc(existingFoto)} alt="foto" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <UserOutlined style={{ fontSize: 48, color: '#bfbfbf' }} />
              )}
              <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'opacity 0.2s' }}
                className="foto-overlay-edit"
              >
                <span style={{ fontSize: 11, fontWeight: 600, color: '#595959', textAlign: 'center', lineHeight: 1.2 }}>
                  {fotoUploading ? 'Subiendo...' : 'Cargar imagen'}
                </span>
              </div>
            </div>
          </Upload>
        </div>
        <Row gutter={16}>
        <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
          <Form.Item
            name="periodo_id"
            label="Tipo Periodo"
            rules={[{ required: true, message: 'Por favor selecciona un tipo de periodo' }]}
          >
            <Select placeholder="Por favor selecciona un tipo de periodo">
              {tipoPeriodo.map((item) => (
                <Option value={item.value} key={item.value}>{item.text}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
          <Form.Item
            name="analitica_id"
            label="Analítica"
            rules={[{ required: true, message: 'Por favor selecciona una analítica' }]}
          >
            <Select placeholder="Por favor selecciona una analítica">
              {analiticas.map((item) => (
                <Option value={item.id} key={item.id}>{item.name}</Option>
              ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
    </>);

    const renderCreateTabs = () => (
      <Tabs
        defaultActiveKey="generales"
        items={[
          {
            key: 'generales',
            label: 'Datos Generales',
            children: (
              <>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
                  <Upload beforeUpload={beforeFotoUploadEdit} showUploadList={false} accept="image/*" disabled={fotoUploading}>
                    <div style={{ position: 'relative', width: 120, height: 120, borderRadius: 8, overflow: 'hidden', cursor: 'pointer', border: '1px solid #d9d9d9', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' }}>
                      {selectedFoto ? (
                        <img src={normalizeFotoSrc(selectedFoto)} alt="foto" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <UserOutlined style={{ fontSize: 48, color: '#bfbfbf' }} />
                      )}
                      <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'opacity 0.2s' }}
                        className="foto-overlay-edit"
                      >
                        <span style={{ fontSize: 11, fontWeight: 600, color: '#595959', textAlign: 'center', lineHeight: 1.2 }}>
                          {fotoUploading ? 'Subiendo...' : 'Cargar imagen'}
                        </span>
                      </div>
                    </div>
                  </Upload>
                </div>
                <h3 style={{ marginBottom: 16 }}>Informacion de Contacto</h3>
                <Row gutter={16}>
                  <Col span={12}><Form.Item name="nomina_name" label="Nombres" rules={[{ required: true, message: 'Captura el nombre' }]}><Input /></Form.Item></Col>
                  <Col span={6}><Form.Item name="nomina_first_last_name" label="Apellido Paterno" rules={[{ required: true, message: 'Captura el apellido paterno' }]}><Input /></Form.Item></Col>
                  <Col span={6}><Form.Item name="nomina_second_last_name" label="Apellido Materno" rules={[{ required: true, message: 'Captura el apellido materno' }]}><Input /></Form.Item></Col>
                  <Col span={12}><Form.Item name="work_email" label="Correo de Trabajo" rules={[{ type: 'email', message: 'Correo inválido' }]}><Input /></Form.Item></Col>
                  <Col span={12}><Form.Item name="work_phone" label="Telefono de Trabajo"><Input /></Form.Item></Col>
                </Row>

                <h3 style={{ marginBottom: 16, marginTop: 8 }}>Direccion Particular</h3>
                <Row gutter={16}>
                  <Col span={8}><Form.Item name="private_street" label="Calle"><Input /></Form.Item></Col>
                  <Col span={8}><Form.Item name="private_street2" label="Colonia"><Input /></Form.Item></Col>
                  <Col span={8}><Form.Item name="private_city" label="Ciudad"><Input /></Form.Item></Col>
                </Row>

                <h3 style={{ marginBottom: 16, marginTop: 8 }}>Informacion Laboral</h3>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item name="job_id" label="Puesto" rules={[{ required: true, message: 'Selecciona un puesto' }]}>
                      <Select allowClear placeholder="Selecciona un puesto">
                        {puestos.map((item) => <Option value={item.value} key={item.value}>{item.text}</Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}><Form.Item name="analitica_id" label="Analítica"><Select allowClear>{analiticas.map((item) => <Option value={item.id} key={item.id}>{item.name}</Option>)}</Select></Form.Item></Col>
                  <Col span={8}>
                    <Form.Item name="odoo_parent_id" label="Supervisor">
                      <Select allowClear placeholder="Selecciona un supervisor">
                        {supervisores.map((item) => <Option value={item.value} key={item.value}>{item.text}</Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="resource_calendar_id" label="Horario de Trabajo">
                      <Select allowClear placeholder="Selecciona un horario">
                        {horarios.map((item) => <Option value={item.id} key={item.id}>{item.descripcion}</Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            ),
          },
          {
            key: 'nomina',
            label: 'Datos de Nómina',
            children: (
              <>
                <h3 style={{ marginBottom: 16 }}>Empleado</h3>
                <Row gutter={16}>
                  <Col span={8}><Form.Item name="nomina_rfc" label="RFC" rules={[{ required: true, message: 'Captura el RFC' }]}><Input /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_curp" label="CURP" rules={[{ required: true, message: 'Captura el CURP' }]}><Input /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_imss_number" label="NSS" rules={[{ required: true, message: 'Captura el NSS' }]}><Input /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_employee_number" label="Número de Empleado" rules={[{ required: true, message: 'Captura el número de empleado' }]}><Input /></Form.Item></Col>
                  <Col span={8}>
                    <Form.Item name="department_id" label="Departamento" rules={[{ required: true, message: 'Selecciona un departamento' }]}>
                      <Select allowClear placeholder="Selecciona un departamento">
                        {departamentos.map((item) => <Option value={item.value} key={item.value}>{item.text}</Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="nomina_workarea_id" label="Área" rules={[{ required: true, message: 'Selecciona un área' }]}>
                      <Select allowClear placeholder="Selecciona un área">
                        {areasTrabajo.map((item) => <Option value={item.value} key={item.value}>{item.text}</Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}><Form.Item name="nomina_entry_date" label="Fecha de Ingreso" rules={[{ required: true, message: 'Selecciona la fecha de ingreso' }]}><DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_seniority_date" label="Fecha de Antigüedad" rules={[{ required: true, message: 'Selecciona la fecha de antigüedad' }]}><DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" /></Form.Item></Col>
                  <Col span={8}>
                    <Form.Item name="nomina_contract_type_id" label="Tipo de Contrato" rules={[{ required: true, message: 'Selecciona el tipo de contrato' }]}>
                      <Select allowClear placeholder="Selecciona un tipo de contrato">
                        {tiposContrato.map((item) => <Option value={item.value} key={item.value}>{item.displayTitle || item.text}</Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}><Form.Item name="nomina_contract_start_date" label="Fecha Inicio Contrato" rules={[{ required: true, message: 'Selecciona la fecha de inicio de contrato' }]}><DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_contract_end_date" label="Fecha Fin Contrato"><DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_need_timesheets" valuePropName="checked"><Checkbox>Checa tarjeta</Checkbox></Form.Item></Col>
                </Row>

                <h3 style={{ marginBottom: 16, marginTop: 8 }}>Salario</h3>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item name="nomina_integration_id" label="Integración" rules={[{ required: true, message: 'Selecciona una integración' }]}>
                      <Select allowClear placeholder="Selecciona integración">
                        {integraciones.map((item) => <Option value={item.value} key={item.value}>{item.text}</Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}><Form.Item name="periodo_id" label="Tipo de Periodo" rules={[{ required: true, message: 'Selecciona un tipo de periodo' }]}><Select allowClear placeholder="Selecciona un tipo de periodo">{tipoPeriodo.map((item) => <Option value={item.value} key={item.value}>{item.text}</Option>)}</Select></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_daily_salary" label="Salario Diario" rules={[{ required: true, message: 'Captura el salario diario' }]}><InputNumber min={0} style={{ width: '100%' }} /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_variable_amount" label="Monto Variable" rules={[{ required: true, message: 'Captura el monto variable' }]}><InputNumber min={0} style={{ width: '100%' }} /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_fixed_amount" label="Monto Fijo" rules={[{ required: true, message: 'Captura el monto fijo' }]}><InputNumber min={0} style={{ width: '100%' }} /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_monthly_salary" label="Salario Mensual (calculado)" rules={[{ required: true, message: 'Se requiere salario mensual' }]}><InputNumber min={0} style={{ width: '100%' }} disabled /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_integration_factor" label="Factor de Integración (calculado)"><InputNumber min={0} style={{ width: '100%' }} disabled /></Form.Item></Col>
                  <Col span={8}><Form.Item name="nomina_integrated_salary" label="Salario Integrado (calculado)"><InputNumber min={0} style={{ width: '100%' }} disabled /></Form.Item></Col>
                </Row>

                <h3 style={{ marginBottom: 16, marginTop: 8 }}>Datos SAT</h3>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item name="nomina_employee_registration_key" label="Registro Patronal" rules={[{ required: true, message: 'Selecciona un registro patronal' }]}>
                      <Select allowClear placeholder="Selecciona un registro patronal">
                        {registroPatronalList.map((item) => (
                          <Option value={item.clave_patronal || item.value} key={item.clave_patronal || item.value}>{item.displayTitle}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}><Form.Item name="nomina_zip_code" label="Código Postal" rules={[{ required: true, message: 'Captura el código postal' }]}><Input maxLength={5} /></Form.Item></Col>
                  <Col span={8}>
                    <Form.Item name="banco_id" label="Banco de Depósito" rules={[{ required: true, message: 'Selecciona un banco de depósito' }]}>
                      <Select allowClear showSearch optionFilterProp="children" placeholder="Selecciona un banco">
                        {bancos.map((item) => (
                          <Option value={item.id} key={item.id}>{item.display_name || item.name}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="nomina_wage_scheme"
                      label="Régimen Salarial"
                      rules={[{ required: true, message: 'Selecciona un régimen salarial' }]}
                    >
                      <Select allowClear placeholder="Selecciona un régimen salarial">
                        {regimenesSalariales.map((item) => (
                          <Option value={item.value} key={item.value}>{item.text}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="nomina_can_reenter" valuePropName="checked">
                      <Checkbox>Permitir reingreso</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />
    );

    return (
      <>
        <style>{`.foto-overlay-edit { opacity: 0; } .foto-overlay-edit:hover { opacity: 1; }`}</style>
      <Drawer
        title={
          <>
            {isEdit ? '(' + id + ') ' : ''}
            {title}
          </>
        }
        placement={"right"}
        onClose={onClose}
        open={open}
        closable={true}
        width={'50%'}
        height={'100%'}
        loading={loadingData}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={[
          <Space>
            <Button onClick={onClose}>Cancelar</Button>
            <Button onClick={handleOk} type="primary">
              Guardar
            </Button>
          </Space>,
        ]}
      >
        <Form
          layout="vertical"
          form={form}
          requiredMark
          onFinish={handleOk}
        >
          {isEdit ? renderEditForm() : renderCreateTabs()}
        </Form>
    
        {isEdit && (
          <div style={{ marginTop: '20px' }}>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Kardex</h2>
            <Table
              columns={[
                {
                  title: "Fecha",
                  dataIndex: "fecha",
                  key: "fecha",
                },
                {
                  title: "Movimiento",
                  dataIndex: "movimiento",
                  key: "movimiento",
                },
                {
                  title: "Descripción",
                  dataIndex: "descripcion",
                  key: "descripcion",
                },
                {
                  title: "Comentarios",
                  dataIndex: "comentarios",
                  key: "comentarios",
                },
              ]}
              dataSource={kardex}
              loading={loadingKardex}
              bordered
              pagination={{ pageSize: 5 }}
              style={{ margin: "20px" }}
            />
          </div>
        )}
      </Drawer>
    </>
    );
};
export default App;